import { render, staticRenderFns } from "./NewsSaveBtn.vue?vue&type=template&id=576f422c&"
import script from "./NewsSaveBtn.vue?vue&type=script&lang=js&"
export * from "./NewsSaveBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports